import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Plus,
  Trash2,
  Play,
  Code,
  ChevronDown,
  ChevronUp,
  Sliders,
  CheckSquare,
  Loader2,
} from "lucide-react";
import { ColumnsByTable, getThemeURL, tableListFilltered} from "../../../Services/EndPoints";
import { getData } from "../../../Services/Services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfirmationModal } from "../../../Components/UiComponents/utils";

const QueryBuilder = () => {
  const navigate = useNavigate();
  const [sourceName, setSourceName] = useState("");
  const [selectedTable, setSelectedTable] = useState("");
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [jsonQuery, setJsonQuery] = useState("");
  const [showQueryBuilder, setShowQueryBuilder] = useState(false);
  const [showJsonResponse, setShowJsonResponse] = useState(false);
  const [jsonResponse, setJsonResponse] = useState(null);
  const [isQueryBuilderExpanded, setIsQueryBuilderExpanded] = useState(true);
  const [showColumnSelection, setShowColumnSelection] = useState(false);
  const [conditions, setConditions] = useState([]);
  const [tablesData, setTablesData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [columnDataTypes, setColumnDataTypes] = useState({});
  const [loadingColumns, setLoadingColumns] = useState(false);
  const [columnError, setColumnError] = useState(null);
  const [orderByFields, setOrderByFields] = useState([]);
  const [isExecuting, setIsExecuting] = useState(false);
  const [serviceDescription, setServiceDescription] = useState("");
  const [compactJsonQuery, setCompactJsonQuery] = useState("");
  const [editId, setEditId] = useState(null);
  const [joins, setJoins] = useState([]);
  const [joinTableColumns, setJoinTableColumns] = useState({});
  const [aggregators, setAggregators] = useState([]);
  const [groupByFields, setGroupByFields] = useState([]);
  const [selectedWidget, setSelectedWidget] = useState("");
  const location = useLocation();
  const queryToEdit = location.state?.queryToEdit || null;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [savedQueries, setSavedQueries] = useState([]);
  const [searchData, setSearchData] = useState([]);
  // Add this with your other useState declarations
const [confirmModal, setConfirmModal] = useState({
  isOpen: false,
  title: "",
  message: "",
  onConfirm: null,
});

  

  const Widgets = [
  { display: "Card", value: "CARD" },
  { display: "Chart", value: "CHART" }, 
  { display: "Map", value: "MAP" },
  { display: "Table", value: "TABLE" }
];

  const operatorTypes = [
    "=",
    "!=",
    ">",
    "<",
    ">=",
    "<=",
    "LIKE",
    "NOT LIKE",
    "IN",
    "NOT IN",
    "BETWEEN",
  ];

  const aggregatorTypes = ["SUM", "MIN", "MAX", "AVG", "COUNT"];

  const joinTypes = ["INNER", "LEFT", "RIGHT"];
  const conditionTypes = ["AND", "OR"];

  const fetchColumnsByTable = async (tableName) => {
    try {
      setLoadingColumns(true);
      setColumnError(null);
      const response = await getData(ColumnsByTable + tableName);

      const columns = response.map((col) => col.columnName);
      const types = {};
      response.forEach((col) => {
        types[col.columnName] = col.dataType;
      });

      setTableColumns(columns);
      setColumnDataTypes(types);
      // const autoSelected = autoSelectRequiredColumns(columns);
    // if (autoSelected.length > 0) {
    //   setSelectedColumns(prev => {
    //     const newSelection = [...new Set([...prev, ...autoSelected])];
    //     // Show toast notification for auto-selected columns
    //     // if (autoSelected.length > 0) {
    //     //   toast.info(`Auto-selected: ${autoSelected.join(', ')}`, {
    //     //     position: "top-center",
    //     //     autoClose: 3000
    //     //   });
    //     // }
    //     return newSelection;
    //   });
    // }
    } catch (error) {
      setColumnError("Failed to load columns for the selected table");
      setTableColumns([]);
      setColumnDataTypes({});
    } finally {
      setLoadingColumns(false);
    }
  };

  const fetchColumnsForJoinTable = async (tableName) => {
    try {
      const response = await getData(ColumnsByTable + tableName);
      const columns = response.map((col) => col.columnName);
      const types = {};
      response.forEach((col) => {
        types[col.columnName] = col.dataType;
      });

      setJoinTableColumns((prev) => ({
        ...prev,
        [tableName]: {
          columns,
          dataTypes: types,
        },
      }));
      // const autoSelected = autoSelectRequiredColumns(columns);
    // if (autoSelected.length > 0) {
    //   // Find the join index for this table
    //   const joinIndex = joins.findIndex(join => join.table === tableName);
    //   if (joinIndex !== -1) {
    //     const newJoins = [...joins];
    //     const currentJoinColumns = newJoins[joinIndex].columns || [];
    //     const updatedJoinColumns = [...new Set([...currentJoinColumns, ...autoSelected])];
        
    //     newJoins[joinIndex].columns = updatedJoinColumns;
    //     setJoins(newJoins);
        
    //     // toast.info(`Auto-selected for ${tableName}: ${autoSelected.join(', ')}`, {
    //     //   position: "top-center",
    //     //   autoClose: 3000
    //     // });
    //   }
    // }
    } catch (error) {
      setJoinTableColumns((prev) => ({
        ...prev,
        [tableName]: {
          columns: [],
          dataTypes: {},
        },
      }));
    }
  };

  const addJoin = () => {
    if (!selectedTable) {
      toast.error("Please select a main table first", {
        position: "top-center",
      });
      return;
    }

    // Validate existing joins before adding new one
    const joinErrors = validateJoins();
    if (joinErrors.length > 0) {
      toast.error(
        `Please fix existing join issues before adding a new join: ${joinErrors[0]}`,
        { position: "top-center" }
      );
      return;
    }

    // Check maximum joins limit
    if (joins.length >= 20) {
      toast.warning("Maximum of 20 joins allowed for performance reasons", {
        position: "top-center",
      });
      return;
    }

    const newJoin = {
      table: "",
      type: "INNER",
      conditions: [
        {
          leftTable: selectedTable, 
          firstTableColumn: "",
          secondTableColumn: "",
          operator: "=",
          conditionType: "AND",
        },
      ],
    };

    setJoins([...joins, newJoin]);
    toast.success("New join added successfully", { position: "top-center" });
  };

 const updateJoin = (index, field, value) => {
  // Validate before updating
  if (field === "table" && value) {
    // Check for duplicate table selection
    const existingTables = joins
      .map((join, idx) => (idx !== index ? join.table : null))
      .filter(Boolean);

    if (existingTables.includes(value)) {
      toast.error(`Table '${value}' is already being used in another join`, {
        position: "top-center",
      });
      return;
    }

    // Check for self-join
    if (value === selectedTable) {
      toast.error("Cannot join a table with itself", {
        position: "top-center",
      });
      return;
    }
  }

  const newJoins = [...joins];
  
  // **FIX: Clear columns and conditions when table changes**
  if (field === "table" && value !== newJoins[index].table) {
    newJoins[index] = { 
      ...newJoins[index], 
      [field]: value,
      columns: [], // Clear previously selected columns
      conditions: [
        {
          leftTable: selectedTable,
          firstTableColumn: "",
          secondTableColumn: "",
          operator: "=",
          conditionType: "AND",
        },
      ] // Reset conditions with proper structure
    };
    
    // Show notification about the reset
    toast.info(`Table changed to ${value}. Previous column selections and join conditions have been reset.`, {
      position: "top-center",
      autoClose: 4000
    });
  } else {
    newJoins[index] = { ...newJoins[index], [field]: value };
  }

  if (field === "table" && value) {
    if (!joinTableColumns[value]) {
      fetchColumnsForJoinTable(value);
      toast.info(`Loading columns for table: ${value}`, {
        position: "top-center",
      });
    }
  }

  setJoins(newJoins);
};


const removeJoin = (index) => {
  const joinToRemove = joins[index];

  if (
    joinToRemove.table &&
    joinToRemove.conditions.some(
      (c) => c.firstTableColumn && c.secondTableColumn
    )
  ) {
    // Show custom confirmation modal for configured joins
    setConfirmModal({
      isOpen: true,
      title: "Remove Join ?",
      message: `Are you sure you want to remove the join with '${joinToRemove.table}'? This will also remove any selected columns from this table.`,
      onConfirm: () => {
        performRemoveJoin(index);
        setConfirmModal({ isOpen: false, title: "", message: "", onConfirm: null });
      },
    });
  } else {
    // Directly remove if no configuration exists
    performRemoveJoin(index);
  }
};

// Extract the actual removal logic into a separate function
const performRemoveJoin = (index) => {
  const newJoins = [...joins];
  const removedJoin = newJoins.splice(index, 1)[0];

  // Clean up join table columns if no longer used
  const tableStillUsed = newJoins.some((j) => j.table === removedJoin.table);
  if (!tableStillUsed && removedJoin.table) {
    setJoinTableColumns((prev) => {
      const newState = { ...prev };
      delete newState[removedJoin.table];
      return newState;
    });
  }

  setJoins(newJoins);
  toast.success(
    `Join with '${removedJoin.table || "unnamed table"}' removed`,
    { position: "top-center" }
  );
};


const addJoinCondition = (joinIndex) => {
  const join = joins[joinIndex];

  if (!join.table) {
    toast.error("Please select a join table before adding conditions", {
      position: "top-center",
    });
    return;
  }

  if (join.conditions.length >= 20) {
    toast.warning(
      "Maximum of 20 conditions per join recommended for performance",
      { position: "top-center" }
    );
    return;
  }

  const newJoins = [...joins];
  newJoins[joinIndex].conditions.push({
    leftTable: selectedTable, // Default to main table
    firstTableColumn: "",
    secondTableColumn: "",
    operator: "=",
    conditionType: "AND",
  });
  setJoins(newJoins);
  toast.success("Join condition added", { position: "top-center" });
};


 const updateJoinCondition = (joinIndex, conditionIndex, field, value) => {
  const newJoins = [...joins];
  const currentCondition = newJoins[joinIndex].conditions[conditionIndex];

  // Validate column selection based on table
  if (field === "firstTableColumn" && value) {
    const leftTable = currentCondition.leftTable || selectedTable;
    const availableColumns = leftTable === selectedTable 
      ? tableColumns 
      : (joinTableColumns[leftTable]?.columns || []);
    
    if (!availableColumns.includes(value)) {
      toast.error(`Column '${value}' not found in ${leftTable}`, {
        position: "top-center",
      });
      return;
    }
  }

  if (field === "secondTableColumn" && value) {
    const joinTable = newJoins[joinIndex].table;
    const joinColumns = joinTableColumns[joinTable]?.columns || [];
    if (!joinColumns.includes(value)) {
      toast.error(`Column '${value}' not found in join table`, {
        position: "top-center",
      });
      return;
    }
  }

  newJoins[joinIndex].conditions[conditionIndex] = {
    ...currentCondition,
    [field]: value,
  };

  setJoins(newJoins);
};


  const removeJoinCondition = (joinIndex, conditionIndex) => {
    const newJoins = [...joins];
    newJoins[joinIndex].conditions.splice(conditionIndex, 1);
    setJoins(newJoins);
  };

  const toggleJoinColumnSelection = (joinIndex, column) => {
    const newJoins = [...joins];
    const joinColumns = newJoins[joinIndex].columns || [];

    if (joinColumns.includes(column)) {
      newJoins[joinIndex].columns = joinColumns.filter((col) => col !== column);
    } else {
      newJoins[joinIndex].columns = [...joinColumns, column];
    }

    setJoins(newJoins);
  };

  const fetchAllTables = async () => {
    try {
      const response = await getData(tableListFilltered);
      if (response && Array.isArray(response)) {
        setTablesData(response);
      }
    } catch (error) {}
  };

  const addAggregator = () => {
  setAggregators([...aggregators, { 
    table: selectedTable, // Default to main table
    function: "SUM", 
    column: "", 
    alias: "" 
  }]);
};


const removeAggregator = (index) => {
  const newAggregators = [...aggregators];
  newAggregators.splice(index, 1);
  setAggregators(newAggregators);
};
const updateAggregator = (index, field, value) => {
  const newAggregators = [...aggregators];
  
  // If table is being changed, reset the column
  if (field === 'table') {
    newAggregators[index] = { 
      ...newAggregators[index], 
      [field]: value, 
      column: "" // Reset column when table changes
    };
  } else {
    newAggregators[index] = { ...newAggregators[index], [field]: value };
  }
  
  setAggregators(newAggregators);
};
const addGroupByField = () => {
  setGroupByFields([...groupByFields, { 
    table: selectedTable, // Default to main table
    column: "" 
  }]);
};


  useEffect(() => {
    fetchAllTables();
  }, []);
useEffect(() => {
  if (queryToEdit) {
    // Expand the query builder when editing
    setShowQueryBuilder(true);
    setIsQueryBuilderExpanded(true);
    const { serviceName, serviceDescription, queryBuilder, id, widgetType } = queryToEdit;

    setSourceName(serviceName || "");
    setServiceDescription(serviceDescription || "");
    setSelectedWidget(widgetType || "");

    const mainTable = queryBuilder.entity?.split(".")[1] || "";
    setSelectedTable(mainTable);

    // Process columns to separate regular columns and aggregators
    const regularColumns = [];
    const processedAggregators = [];

    (queryBuilder.columns || []).forEach((col) => {
      // Check if column contains aggregator function
      const aggregatorMatch = col.match(/^(SUM|MIN|MAX|AVG|COUNT)\(([^)]+)\)$/);
      
      if (aggregatorMatch) {
        const [, func, column] = aggregatorMatch;
        
        // Extract table and column from the column reference
        let tableName, columnName;
        if (column.includes('.')) {
          [tableName, columnName] = column.split('.');
        } else {
          // If no table prefix, assume it's the main table
          tableName = mainTable;
          columnName = column;
        }
        
        processedAggregators.push({
          function: func,
          table: tableName,
          column: columnName,
          alias: ""
        });
      } else if (col.startsWith(`${mainTable}.`)) {
        regularColumns.push(col.split(".")[1]);
      }
    });

    setSelectedColumns(regularColumns);
    setAggregators(processedAggregators);

    setCompactJsonQuery(JSON.stringify(queryBuilder));
    setJsonQuery(JSON.stringify(queryBuilder, null, 2));

    // *** FIXED: Process conditions/filters to handle both single and array formats ***
    const conditions = [];
    if (queryBuilder.filters) {
      for (const field in queryBuilder.filters) {
        const filterValue = queryBuilder.filters[field];
        
        // Extract table and column name from the field
        let tableName, columnName;
        if (field.includes(".")) {
          [tableName, columnName] = field.split(".");
        } else {
          // If no table prefix, assume it's the main table
          tableName = mainTable;
          columnName = field;
        }

        // Handle array of conditions for the same field
        if (Array.isArray(filterValue)) {
          filterValue.forEach((condition) => {
            if (typeof condition === "object" && condition.operator) {
              let processedValue;
              
              if (["IN", "NOT IN"].includes(condition.operator)) {
                processedValue = Array.isArray(condition.value) ? condition.value.join(",") : condition.value;
              } else if (condition.operator === "BETWEEN") {
                processedValue = Array.isArray(condition.value) ? condition.value.join(",") : condition.value;
              } else {
                processedValue = Array.isArray(condition.value) ? condition.value.join(",") : condition.value;
              }

              conditions.push({
                table: tableName,
                field: columnName,
                operator: condition.operator,
                value: processedValue,
              });
            } else {
              // Simple value in array (shouldn't happen but handle it)
              conditions.push({
                table: tableName,
                field: columnName,
                operator: "=",
                value: condition,
              });
            }
          });
        }
        // Handle single condition (existing logic)
        else if (typeof filterValue === "object" && filterValue.operator) {
          let processedValue;
          
          if (["IN", "NOT IN"].includes(filterValue.operator)) {
            processedValue = Array.isArray(filterValue.value) ? filterValue.value.join(",") : filterValue.value;
          } else if (filterValue.operator === "BETWEEN") {
            processedValue = Array.isArray(filterValue.value) ? filterValue.value.join(",") : filterValue.value;
          } else {
            processedValue = Array.isArray(filterValue.value) ? filterValue.value.join(",") : filterValue.value;
          }

          conditions.push({
            table: tableName,
            field: columnName,
            operator: filterValue.operator,
            value: processedValue,
          });
        } else {
          // Simple equality condition
          conditions.push({
            table: tableName,
            field: columnName,
            operator: "=",
            value: String(filterValue),
          });
        }
      }
    }
    setConditions(conditions);

    // Process order by fields - FIXED
    if (Array.isArray(queryBuilder.orderBy)) {
      const processedOrderBy = queryBuilder.orderBy.map((field) => {
        if (field.column.includes(".")) {
          const [tableName, columnName] = field.column.split(".");
          return {
            table: tableName,
            column: columnName,
            direction: field.direction,
          };
        } else {
          return {
            table: mainTable, // Default to main table
            column: field.column,
            direction: field.direction,
          };
        }
      });
      setOrderByFields(processedOrderBy);
    }

    // Process group by fields - FIXED
    if (Array.isArray(queryBuilder.groupBy)) {
      const processedGroupBy = queryBuilder.groupBy.map((field) => {
        if (field.includes(".")) {
          const [tableName, columnName] = field.split(".");
          return {
            table: tableName,
            column: columnName
          };
        } else {
          return {
            table: mainTable, // Default to main table
            column: field
          };
        }
      });
      setGroupByFields(processedGroupBy);
    }
    
    // Process joins (existing code remains the same)
    if (Array.isArray(queryBuilder.joins)) {
      const processedJoins = queryBuilder.joins.map((join) => {
        const tableName = join.table.split(".")[1];
        const alias = join.alias || tableName;

        // Extract columns that belong to this join table from the main columns list
        const joinColumns = (queryBuilder.columns || [])
          .filter((col) => col.startsWith(`${alias}.`))
          .map((col) => col.split(".")[1]);

        const conditions = [];

        // Parse the ON condition into individual conditions
        if (join.on) {
          const conditionParts = join.on.split(/( and | or )/i);
          let currentConditionType = "AND";

          for (let i = 0; i < conditionParts.length; i++) {
            const part = conditionParts[i].trim();
            if (part.toLowerCase() === "and" || part.toLowerCase() === "or") {
              currentConditionType = part.toUpperCase();
              continue;
            }

            if (part) {
              const [left, right] = part.split(/\s*=\s*/);
              
              // Parse left side (should be main table column)
              let leftTable, leftColumn;
              if (left.includes('.')) {
                [leftTable, leftColumn] = left.split('.');
              } else {
                leftTable = mainTable;
                leftColumn = left;
              }
              
              // Parse right side (should be join table column)
              let rightTable, rightColumn;
              if (right.includes('.')) {
                [rightTable, rightColumn] = right.split('.');
              } else {
                rightTable = alias;
                rightColumn = right;
              }

              conditions.push({
                leftTable: leftTable,
                firstTableColumn: leftColumn,
                secondTableColumn: rightColumn,
                operator: "=",
                conditionType: currentConditionType,
              });
            }
          }
        }

        return {
          table: tableName,
          type: join.type,
          conditions,
          columns: joinColumns,
        };
      });

      setJoins(processedJoins);

      // Fetch columns for join tables
      queryBuilder.joins.forEach((join) => {
        const tableName = join.table.split(".")[1];
        if (tableName) {
          fetchColumnsForJoinTable(tableName);
        }
      });
    }

    setEditId(id);
  }
}, [queryToEdit]);

  useEffect(() => {
    if (selectedTable) {
      fetchColumnsByTable(selectedTable);
    } else {
      setTableColumns([]);
      setColumnDataTypes({});
    }
  }, [selectedTable]);

  const getDataTypeForField = (tableName, fieldName) => {
  if (tableName === selectedTable) {
    return columnDataTypes[fieldName];
  } else {
    return joinTableColumns[tableName]?.dataTypes?.[fieldName];
  }
};
const validateValue = (table, field, value, operator) => {
  if (!field || !value) return true;

  const dataType = getDataTypeForField(table, field);
  if (!dataType) return true;

  const normalizedDataType = dataType.toLowerCase();

  if (["IN", "NOT IN"].includes(operator)) {
    const values = value.split(",").map((v) => v.trim()).filter(v => v !== '');
    if (values.length === 0) return false;
    return values.every((v) => validateSingleValue(normalizedDataType, v));
  }

  if (operator === "BETWEEN") {
    const values = value.split(",").map((v) => v.trim()).filter(v => v !== '');
    if (values.length !== 2) return false;
    return values.every((v) => validateSingleValue(normalizedDataType, v));
  }

  return validateSingleValue(normalizedDataType, value);
};

// Enhance the validateSingleValue function
const validateSingleValue = (dataType, value) => {
  if (!dataType) return true;

  try {
    // Handle numeric types
    if (dataType.includes("int") || 
        dataType.includes("bigint") || 
        dataType.includes("smallint") ||
        dataType.includes("serial")) {
      return !isNaN(value) && Number.isInteger(Number(value));
    }
    
    if (dataType.includes("numeric") || 
        dataType.includes("decimal") || 
        dataType.includes("float") || 
        dataType.includes("double") ||
        dataType.includes("real")) {
      return !isNaN(value);
    }
    
    // Handle boolean types
    if (dataType.includes("boolean") || dataType.includes("bool")) {
      return ["true", "false", "1", "0", "yes", "no", "t", "f", "y", "n"]
        .includes(value.toLowerCase().trim());
    }
    
    // Handle date/time types
    if (dataType.includes("date") || 
        dataType.includes("timestamp") || 
        dataType.includes("time")) {
      // Try to parse as date
      const date = new Date(value);
      return !isNaN(date.getTime());
    }
    
    // Handle string types - most things can be strings
    if (dataType.includes("varchar") || 
        dataType.includes("text") || 
        dataType.includes("char") ||
        dataType.includes("string")) {
      return true; // Strings can accept almost anything
    }
    
    // Handle specific PostgreSQL types
    if (dataType.includes("uuid")) {
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
    }
    
    if (dataType.includes("json") || dataType.includes("jsonb")) {
      try {
        JSON.parse(value);
        return true;
      } catch {
        return false;
      }
    }
    
    // Default case - be permissive for unknown types
    return true;
  } catch (e) {
    return false;
  }
};

// Add this function to get validation error messages
const getValidationErrorMessage = (dataType, operator, value) => {
  const normalizedDataType = dataType?.toLowerCase() || '';
  
  if (["IN", "NOT IN"].includes(operator)) {
    const values = value.split(",").map((v) => v.trim()).filter(v => v !== '');
    if (values.length === 0) {
      return "Please provide at least one value";
    }
  }

  if (operator === "BETWEEN") {
    const values = value.split(",").map((v) => v.trim()).filter(v => v !== '');
    if (values.length !== 2) {
      return "BETWEEN requires exactly 2 comma-separated values";
    }
  }

  if (normalizedDataType.includes("int") || normalizedDataType.includes("numeric")) {
    return `Enter a valid ${normalizedDataType.includes("int") ? "integer" : "number"}`;
  }

  if (normalizedDataType.includes("boolean")) {
    return "Enter true/false, yes/no, or 1/0";
  }

  if (normalizedDataType.includes("date") || normalizedDataType.includes("timestamp")) {
    return "Enter a valid date/time (e.g., 2023-12-31 or 2023-12-31 23:59:59)";
  }

  if (normalizedDataType.includes("uuid")) {
    return "Enter a valid UUID format";
  }

  if (normalizedDataType.includes("json")) {
    return "Enter valid JSON format";
  }

  return "Invalid value for this field type";
};
const isValidQuery = useMemo(() => {
  if (!selectedTable || !selectedWidget) return false;

  // Validate all conditions
  const validConditions = conditions.every((cond) => {
    if (!cond.field || !cond.value) return true;
    return validateValue(cond.table || selectedTable, cond.field, cond.value, cond.operator);
  });

  const validOrderBy = orderByFields.every((field) => field.column);

  const validJoins = joins.every((join) => {
    if (!join.table) return false;
    return join.conditions.every(
      (cond) => cond.firstTableColumn && cond.secondTableColumn
    );
  });

  // Validate that if we have aggregators, we have group by fields
  // const validAggregation = aggregators.length === 0 || groupByFields.length > 0;

  return validConditions && validOrderBy && validJoins
}, [selectedTable, selectedWidget, conditions, orderByFields, columnDataTypes, joins, aggregators, groupByFields]);

  const addOrderByField = () => {
  setOrderByFields([...orderByFields, { 
    table: selectedTable, // Default to main table
    column: "", 
    direction: "ASC" 
  }]);
};

  // Add these validation functions after your existing helper functions

  const validateJoins = () => {
    const errors = [];

    // Check for duplicate join tables
    const joinTables = joins.map((join) => join.table).filter((table) => table);
    const duplicates = joinTables.filter(
      (table, index) => joinTables.indexOf(table) !== index
    );

    if (duplicates.length > 0) {
      errors.push(
        `Duplicate joins detected for tables: ${[...new Set(duplicates)].join(
          ", "
        )}`
      );
    }

    // Check for self-joins (joining table with itself)
    const selfJoins = joins.filter((join) => join.table === selectedTable);
    if (selfJoins.length > 0) {
      errors.push("Cannot join a table with itself");
    }

    // Check for incomplete join configurations
    joins.forEach((join, index) => {
      if (!join.table) {
        errors.push(`Join ${index + 1}: Please select a table to join`);
      }

      if (join.conditions.length === 0) {
        errors.push(
          `Join ${index + 1} (${
            join.table || "unnamed"
          }): At least one join condition is required`
        );
      }

      join.conditions.forEach((condition, condIndex) => {
        if (!condition.firstTableColumn) {
          errors.push(
            `Join ${index + 1} condition ${
              condIndex + 1
            }: Please select a column from ${selectedTable}`
          );
        }
        if (!condition.secondTableColumn) {
          errors.push(
            `Join ${index + 1} condition ${
              condIndex + 1
            }: Please select a column from ${join.table || "join table"}`
          );
        }
      });
    });

    // Check for circular joins (advanced validation)
    const checkCircularJoins = () => {
      // Use plain JavaScript objects instead of Map/Set to avoid potential import issues
      const joinMap = {};
      joinMap[selectedTable] = [];

      joins.forEach((join) => {
        if (join.table) {
          if (!joinMap[join.table]) {
            joinMap[join.table] = [];
          }
          joinMap[selectedTable].push(join.table);
        }
      });

      // Simple circular reference check
      joins.forEach((join) => {
        if (join.table && joinMap[join.table]) {
          const joinTableConnections = joinMap[join.table];
          if (
            joinTableConnections &&
            joinTableConnections.includes(selectedTable)
          ) {
            errors.push(
              `Potential circular reference detected between ${selectedTable} and ${join.table}`
            );
          }
        }
      });
    };

    if (joins.length > 1) {
      checkCircularJoins();
    }

    return errors;
  };

  const validateJoinDataTypes = () => {
    const errors = [];

    joins.forEach((join, joinIndex) => {
      if (!join.table) return;

      join.conditions.forEach((condition, condIndex) => {
        const { firstTableColumn, secondTableColumn } = condition;

        if (firstTableColumn && secondTableColumn) {
          const firstColumnType = columnDataTypes[firstTableColumn];
          const secondColumnType =
            joinTableColumns[join.table]?.dataTypes?.[secondTableColumn];

          if (firstColumnType && secondColumnType) {
            // Simplified type compatibility check
            const isCompatible = areTypesCompatible(
              firstColumnType,
              secondColumnType
            );

            if (!isCompatible) {
              errors.push(
                `Join ${joinIndex + 1} condition ${condIndex + 1}: ` +
                  `Column types don't match - ${selectedTable}.${firstTableColumn} (${firstColumnType}) ` +
                  `and ${join.table}.${secondTableColumn} (${secondColumnType})`
              );
            }
          }
        }
      });
    });

    return errors;
  };

  const areTypesCompatible = (type1, type2) => {
  const normalizeType = (type) => {
    const lower = type.toLowerCase();
    if (
      lower.includes("int") ||
      lower.includes("bigint") ||
      lower.includes("smallint")
    )
      return "integer";
    if (
      lower.includes("varchar") ||
      lower.includes("text") ||
      lower.includes("char") ||
      lower.includes("character varying")  // Add this line
    )
      return "string";
    if (
      lower.includes("decimal") ||
      lower.includes("numeric") ||
      lower.includes("float") ||
      lower.includes("double")
    )
      return "decimal";
    if (lower.includes("date") || lower.includes("timestamp")) return "date";
    if (lower.includes("boolean") || lower.includes("bool")) return "boolean";
    return lower;
  };

  return normalizeType(type1) === normalizeType(type2);
};

const buildJsonQuery = () => {
  if (!selectedTable) {
    toast.error("Please select a Table", { position: "top-center" });
    return;
  }
  if (!selectedWidget) {
    toast.error("Please select a Widget Category", { position: "top-center" });
    return;
  }
  
  // Validate joins first
  const joinErrors = validateJoins();
  if (joinErrors.length > 0) {
    toast.error(`Join validation failed: ${joinErrors[0]}`, {
      position: "top-center",
    });
    return;
  }
  
  // Validate join data types
  const typeErrors = validateJoinDataTypes();
  if (typeErrors.length > 0) {
    toast.warning(`Data type mismatch: ${typeErrors[0]}`, {
      position: "top-center",
    });
  }
  
  if (!isValidQuery) {
    toast.error("Some filter values, joins, or order fields are invalid", {
      position: "top-center",
    });
    return;
  }
  
  // Show success message for valid joins
  if (joins.length > 0 && !typeErrors.length > 0) {
    toast.success(`Query built successfully with ${joins.length} join(s)`, {
      position: "top-center",
    });
  }
  
  // Start with base query object
  const queryObject = {
    entity: `core.${selectedTable}`,
    columns: [],
    filters: {},
  };
  
  // Add aggregator columns
  if (aggregators.length > 0) {
    aggregators.forEach((agg) => {
      if (agg.function && agg.column && agg.table) {
        const aggregatorColumn = `${agg.function}(${agg.table}.${agg.column})`;
        queryObject.columns.push(aggregatorColumn);
      }
    });
  }
  
  // Add join columns
  joins.forEach((join) => {
    if (join.columns && join.columns.length > 0 && join.table) {
      const alias = join.table;
      const availableColumns = joinTableColumns[join.table]?.columns || [];
      
      join.columns.forEach((col) => {
        if (availableColumns.includes(col)) {
          queryObject.columns.push(`${alias}.${col}`);
        } else {
          console.warn(`Column '${col}' not found in table '${join.table}', skipping...`);
        }
      });
    }
  });
  
  // Add selected columns from main table
  queryObject.columns.push(...selectedColumns.map((col) => `${selectedTable}.${col}`));
  
  // *** FIXED: Process filters to handle multiple conditions on same column ***
  if (conditions.length > 0) {
    // Group conditions by field
    const groupedConditions = {};
    
    conditions.forEach((condition) => {
      if (condition.table && condition.field && condition.value) {
        const currentTable = condition.table || selectedTable;
        const dataTypes = currentTable === selectedTable 
          ? columnDataTypes 
          : (joinTableColumns[currentTable]?.dataTypes || {});
        
        const dataType = dataTypes[condition.field]?.toLowerCase() || "";
        const prefixedField = `${currentTable}.${condition.field}`;
        
        // Initialize array for this field if it doesn't exist
        if (!groupedConditions[prefixedField]) {
          groupedConditions[prefixedField] = [];
        }
        
        let processedCondition;
        
        // Handle created_on field specially for BETWEEN operator
        if (condition.field.toLowerCase() === "created_on" && 
            condition.operator === "BETWEEN") {
          const values = condition.value.split(",").map(v => v.trim());
          
          if (values.length === 2) {
            const startDate = values[0];
            const endDate = values[1];
            
            let formattedStartDate = startDate;
            if (!startDate.includes(":")) {
              formattedStartDate = `${startDate} 00:00:00.000`;
            }
            
            let formattedEndDate = endDate;
            if (!endDate.includes(":")) {
              formattedEndDate = `${endDate} 23:59:59.999`;
            }
            
            processedCondition = {
              operator: "BETWEEN",
              value: [formattedStartDate, formattedEndDate],
            };
          }
        } 
        else if (["IN", "NOT IN"].includes(condition.operator)) {
          const values = condition.value.split(",").map((v) => {
            const trimmed = v.trim();
            if (dataType.includes("int") || dataType.includes("numeric")) {
              return isNaN(trimmed) ? trimmed : Number(trimmed);
            }
            return trimmed;
          });
          processedCondition = {
            operator: condition.operator,
            value: values,
          };
        } 
        else if (condition.operator === "BETWEEN") {
          const values = condition.value.split(",").map((v) => {
            const trimmed = v.trim();
            if (dataType.includes("int") || dataType.includes("numeric")) {
              return isNaN(trimmed) ? trimmed : Number(trimmed);
            }
            return trimmed;
          });
          
          if (values.length === 2) {
            processedCondition = {
              operator: "BETWEEN",
              value: values,
            };
          }
        } 
        else {
          let processedValue = condition.value;
          if (dataType.includes("int") || dataType.includes("numeric")) {
            processedValue = isNaN(condition.value) ? condition.value : Number(condition.value);
          } else if (dataType.includes("boolean")) {
            processedValue = condition.value.toLowerCase() === "true" || condition.value === "1";
          }
          
          if (["LIKE", "NOT LIKE"].includes(condition.operator)) {
            processedValue = condition.value.includes("%") ? condition.value : `%${condition.value}%`;
            processedCondition = {
              operator: condition.operator,
              value: processedValue,
            };
          } else if (["=","!=", ">", "<", ">=", "<="].includes(condition.operator)) {
            processedCondition = {
              operator: condition.operator,
              value: processedValue,
            };
          } else {
            // For simple equality, store as direct value (backward compatibility)
            processedCondition = processedValue;
          }
        }
        
        if (processedCondition !== undefined) {
          groupedConditions[prefixedField].push(processedCondition);
        }
      }
    });
    
    // Now set the filters based on grouped conditions
    Object.keys(groupedConditions).forEach(field => {
      const conditionsForField = groupedConditions[field];
      
      if (conditionsForField.length === 1) {
        // Single condition - use existing format for backward compatibility
        queryObject.filters[field] = conditionsForField[0];
      } else {
        // Multiple conditions - use array format
        queryObject.filters[field] = conditionsForField;
      }
    });
  }
  
  // Process joins (existing code remains the same)
  if (joins.length > 0) {
    queryObject.joins = joins
      .filter((join) => join.table && join.conditions.length > 0)
      .map((join) => {
        const alias = join.table;
        let onCondition = "";
        join.conditions.forEach((cond, idx) => {
          if (idx > 0) {
            onCondition += ` ${cond.conditionType} `;
          }
          
          const leftSide = `${cond.leftTable || selectedTable}.${cond.firstTableColumn}`;
          const rightSide = `${alias}.${cond.secondTableColumn}`;
          
          onCondition += `${leftSide} ${cond.operator} ${rightSide}`;
        });
        return {
          table: `core.${join.table}`,
          type: join.type,
          on: onCondition,
          alias: alias,
        };
      });
  }
  
  // Process order by (existing code remains the same)
  if (orderByFields.length > 0) {
    queryObject.orderBy = orderByFields
      .filter(field => field.table && field.column)
      .map(field => ({
        column: `${field.table}.${field.column}`,
        direction: field.direction
      }));
  }
  
  // Process GROUP BY
  if (groupByFields.length > 0) {
    queryObject.groupBy = groupByFields
      .filter(field => field.table && field.column)
      .map(field => `${field.table}.${field.column}`);
  }
  
  setJsonQuery(JSON.stringify(queryObject, null, 2));
  setCompactJsonQuery(JSON.stringify(queryObject));
};

  // const saveQuery = async () => {

const saveQuery = async () => {
  if (!sourceName || !selectedTable || !compactJsonQuery) {
    toast.error(
      "Please provide all required fields: Service Name, Table, and build a query first",
      { position: "top-center" }
    );
    return;
  }
 
  try {
    setIsExecuting(true);
 
    // Fetch user ID and role before saving - same as in CreateNewDashboard
    let fetchedUserId = null;
    let adminRole = "";
    let userRoleFromAPI = null;
    let userRegionId = null;
    let userBankId = null;
 
    try {
      const response = await getData(getThemeURL);
      console.log(response, "User profile response");
      if (response && Array.isArray(response) && response.length > 0) {
        fetchedUserId = response[0].id;
        const roleName = response[0].role_name?.toUpperCase();
        userRoleFromAPI = roleName;
        userBankId = response.bank_id;
        console.log("Role name:", roleName);
 
        if (roleName === "SUPER ADMIN") {
          adminRole = "SA";
        } else if (response[0].is_admin === true) {
          adminRole = "HO";
        } else if (roleName === "BRANCH OFFICER") {
          adminRole = "BA";
        } else {
          adminRole = "U";
        }
        console.log("Mapped admin role:", adminRole);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile.", {
        position: "top-center",
      });
      return;
    }
 
    if (!fetchedUserId) {
      toast.error("User ID is not available. Cannot save query.", {
        position: "top-center",
      });
      return;
    }
 
    const payload = {
      serviceName: sourceName,
      serviceDescription: serviceDescription,
      queryBuilder: compactJsonQuery,
      widgetType: selectedWidget,
      created_by: fetchedUserId,
      adminRole: adminRole,
      active_status: true,
      duplicateNameAllow: false,
      queryStage: "PRIMARY",
    };
 
    // Add bank and region info based on role
    if (userBankId) {
      payload.bankId = userBankId;
    }
 
    if (editId) {
      payload.id = editId;
    }
 
    const response = await fetch("/nifi/saveServicebuilder", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
 
    if (!response.ok) {
      throw new Error(`Failed to save query: ${response.status}`);
    }
    console.log(response, "nifiresponse");
 
    const data = await response.json();
    console.log("nifidata", data);
 
    // Handle response based on status
    if (data.status === 'success') {
      toast.success(data.message || "Query saved successfully!", {
        position: "top-center"
      });
      navigate("../querylist");
    } else if (data.status === 'error') {
      // Handle specific error cases
      if (data.code === 409) {
        toast.error(data.message || "Service name already exists. Please choose a different name.", {
          position: "top-center",
        });
      } else {
        toast.error(data.message || "Failed to save query.", {
          position: "top-center",
        });
      }
      // Don't navigate on error
    } else {
      // Fallback for unexpected response format
      toast.error("Unexpected response format.", {
        position: "top-center",
      });
    }
 
  } catch (error) {
    toast.error(`Failed to save query: ${error.message}`, {
      position: "top-center",
    });
  } finally {
    setIsExecuting(false);
  }
};


  const callNiFiAPI = async () => {
    try {
      setIsExecuting(true);
      const queryObject = JSON.parse(jsonQuery);
      const response = await fetch("/nifi/fetchQuery", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(queryObject),
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }

      const data = await response.json();
      setJsonResponse(data);
      setShowJsonResponse(true);
    } catch (error) {
      toast.error(`Failed to fetch response from NiFi: ${error.message}`, {
        position: "top-center",
      });
    } finally {
      setIsExecuting(false);
    }
  };
  
  const addCondition = () => {
  setConditions([...conditions, { 
    table: selectedTable, // Default to main table
    field: "", 
    operator: "=", 
    value: "" 
  }]);
};

const removeCondition = (index) => {
    const newConditions = [...conditions];
    newConditions.splice(index, 1);
    setConditions(newConditions);
  };

// Update the updateCondition function to handle table changes
const updateCondition = (index, field, value) => {
  const newConditions = [...conditions];
  
  // If table is being changed, reset the field
  if (field === 'table') {
    newConditions[index] = { 
      ...newConditions[index], 
      [field]: value, 
      field: "" // Reset field when table changes
    };
  } else {
    newConditions[index] = { ...newConditions[index], [field]: value };
  }
  
  setConditions(newConditions);
};

  // const updateCondition = (index, field, value) => {
  //   const newConditions = [...conditions];
  //   newConditions[index] = { ...newConditions[index], [field]: value };
  //   setConditions(newConditions);
  // };

  const toggleColumnSelection = (column) => {
    setSelectedColumns((prev) =>
      prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column]
    );
  };

  const selectAllColumns = () => {
    if (tableColumns.length > 0) {
      setSelectedColumns([...tableColumns]);
    }
  };

  const clearAllColumns = () => {
    setSelectedColumns([]);
  };

//   const autoSelectRequiredColumns = (columns) => {
//   const requiredColumns = ['bank_id', 'branch_id'];
//   const autoSelected = [];
  
//   requiredColumns.forEach(reqCol => {
//     // Check if the required column exists in the available columns (case-insensitive)
//     const foundColumn = columns.find(col => 
//       col.toLowerCase() === reqCol.toLowerCase()
//     );
    
//     if (foundColumn) {
//       autoSelected.push(foundColumn);
//     }
//   });
  
//   return autoSelected;
// };

  const handleTableChange = (tableName) => {
  setSelectedTable(tableName);
  setConditions([]);
  setSelectedColumns([]);
  setOrderByFields([]);
  setJoins([]);
  setAggregators([]); // Add this line
  setGroupByFields([]); // Add this line
  setSelectedWidget("");
  setJsonQuery("");
  setJsonResponse(null);
};

// Add this function with your other helper functions
// Add this function with your other helper functions
const getOperatorsForDataType = (dataType) => {
  if (!dataType) return ["=", "!=", "IN", "NOT IN"]; // Default operators with IN/NOT IN
  
  const lowerDataType = dataType.toLowerCase();
  
  // Integer types
  if (lowerDataType.includes("int") || lowerDataType === "bigint" || lowerDataType === "smallint") {
    return ["=", "!=", ">", "<", ">=", "<=", "IN", "NOT IN"];
  }
  
  // String types - Add "character varying" here
  if (lowerDataType.includes("varchar") || 
      lowerDataType.includes("text") || 
      lowerDataType.includes("char") ||
      lowerDataType.includes("character varying")) {
    return ["=", "!=", "LIKE", "NOT LIKE", "IN", "NOT IN"];
  }
  
  // Boolean types
  if (lowerDataType.includes("boolean") || lowerDataType.includes("bool")) {
    return ["=", "!="];
  }
  
  // Decimal/Numeric types
  if (lowerDataType.includes("decimal") || lowerDataType.includes("numeric") || 
      lowerDataType.includes("float") || lowerDataType.includes("double")) {
    return ["=", "!=", ">", "<", ">=", "<=", "IN", "NOT IN"];
  }
  
  // Date/Time types
  if (lowerDataType.includes("date") || lowerDataType.includes("timestamp")) {
    return ["=", "!=", ">", "<", ">=", "<=", "BETWEEN", "IN", "NOT IN"];
  }
  
  // UUID types
  if (lowerDataType.includes("uuid")) {
    return ["=", "!=", "IN", "NOT IN"];
  }
  
  // JSON types
  if (lowerDataType.includes("json") || lowerDataType.includes("jsonb")) {
    return ["=", "!="];  // JSON types might not support IN/NOT IN in all databases
  }
  
  // Default operators for unknown types
  return ["=", "!=", "IN", "NOT IN"];
};


  return (
    <div
      style={{
        minHeight: "60vh",
        backgroundColor: "#f9fafb",
        padding: "1rem",
      }}
    >
      <div
        style={{ maxWidth: "80rem", marginLeft: "auto", marginRight: "auto" }}
      >
        {/* Header */}
        <div
          style={{
            borderRadius: "0.75rem",
            padding: "2rem 1.5rem",
            marginBottom: "-1.5rem",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.25rem",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "0.75rem",
                alignItems: "center",
              }}
            >
              <button
                onClick={() => setShowQueryBuilder(!showQueryBuilder)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  padding: "0.625rem 1.25rem",
                  borderRadius: "0.5rem",
                  border: "none",
                  cursor: "pointer",
                  backgroundColor: "#1a7a73",
                  color: "white",
                  fontWeight: "500",
                  marginLeft: "-23px",
                }}
              >
                <Sliders size={18} style={{ flexShrink: 0 }} />
                <span>CSV Query Builder</span>
              </button>
              <button
                onClick={saveQuery}
                disabled={
  isExecuting || !jsonQuery || !isValidQuery || !sourceName || !selectedWidget
}
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor:
                    isExecuting || !jsonQuery || !isValidQuery || !sourceName || !selectedWidget
                      ? "#9ca3af"
                      : "#1a7a73",
                  color: "white",
                  borderRadius: "0.5rem",
                  border: "none",
                  cursor:
                    isExecuting || !jsonQuery || !isValidQuery || !sourceName || !selectedWidget
                      ? "not-allowed"
                      : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                {isExecuting ? (
                  <>
                    <Loader2 size={16} className="animate-spin" />
                    {editId ? "Updating..." : "Saving..."}
                  </>
                ) : (
                  <>
                    <CheckSquare size={16} />
                    {editId ? "Update Query" : "Save Query"}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Query Builder */}
        {showQueryBuilder && (
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "0.75rem",
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
              marginBottom: "1.5rem",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: "#f9fafb",
              }}
              onClick={() => setIsQueryBuilderExpanded(!isQueryBuilderExpanded)}
            >
              <h2
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "600",
                  color: "#1f2937",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Code style={{ color: "#1a7a73" }} size={20} />
                CSV Query Builder
              </h2>
              <button
                style={{
                  color: "#6b7280",
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                }}
              >
                {isQueryBuilderExpanded ? (
                  <ChevronUp size={20} />
                ) : (
                  <ChevronDown size={20} />
                )}
              </button>
            </div>

            {isQueryBuilderExpanded && (
              <div
                style={{ padding: "1.5rem", borderTop: "1px solid #e5e7eb" }}
              >
                {/* Basic Settings */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "1rem",
                    marginBottom: "1.5rem",
                  }}
                >
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        fontWeight: "500",
                      }}
                    >
                      {/* Service Name <span style={{ color: "#ef4444" }}>*</span> */}
                      Service Name <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Service Name"
                      value={sourceName}
                      onChange={(e) => setSourceName(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "0.5rem 0.75rem",
                        border: "1px solid #d1d5db",
                        borderRadius: "0.375rem",
                      }}
                    />
                  </div>

                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        fontWeight: "500",
                      }}
                    >
                      Select Table <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <select
                      value={selectedTable}
                      onChange={(e) => handleTableChange(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "0.5rem 0.75rem",
                        border: "1px solid #d1d5db",
                        borderRadius: "0.375rem",
                      }}
                    >
                      <option value="">Select a table</option>
                      {Array.isArray(tablesData) &&
                        tablesData.map((table) => (
                          <option key={table} value={table}>
                            {table}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        fontWeight: "500",
                      }}
                    >
                      Service Description
                    </label>
                    <input
                      type="text"
                      placeholder="Service Description"
                      value={serviceDescription}
                      onChange={(e) => setServiceDescription(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "0.5rem 0.75rem",
                        border: "1px solid #d1d5db",
                        borderRadius: "0.375rem",
                      }}
                    />
                  </div>
                 <div>
  <label
    style={{
      display: "block",
      marginBottom: "0.5rem",
      fontWeight: "500",
    }}
  >
    Select Widget Category <span style={{ color: "#ef4444" }}>*</span>
  </label>
  <select
    value={selectedWidget}
    onChange={(e) => setSelectedWidget(e.target.value)}
    style={{
      width: "100%",
      padding: "0.5rem 0.75rem",
      border: "1px solid #d1d5db",
      borderRadius: "0.375rem",
    }}
  >
    <option value="">Select a widget type</option>
    {Widgets.map((widget) => (
      <option key={widget.value} value={widget.value}>
        {widget.display}
      </option>
    ))}
  </select>
  
</div>
                </div>

                {/* Column Selection */}
                {selectedTable && (
                  <div
                    style={{
                      backgroundColor: "#f0f9ff",
                      borderRadius: "0.5rem",
                      padding: "1rem",
                      marginBottom: "1.5rem",
                      border: "1px solid #1a7a73",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "1rem",
                      }}
                    >
                      <h3
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: "600",
                          color: "#0f3d3a",
                        }}
                      >
                        Select Columns
                      </h3>
                      <div style={{ display: "flex", gap: "0.5rem" }}>
                        <button
                          onClick={selectAllColumns}
                          disabled={loadingColumns || tableColumns.length === 0}
                          style={{
                            padding: "0.25rem 0.5rem",
                            backgroundColor: "#1a7a73",
                            color: "white",
                            borderRadius: "0.25rem",
                            border: "none",
                            cursor: "pointer",
                            opacity:
                              loadingColumns || tableColumns.length === 0
                                ? 0.5
                                : 1,
                          }}
                        >
                          Select All
                        </button>
                        <button
                          onClick={clearAllColumns}
                          disabled={loadingColumns}
                          style={{
                            padding: "0.25rem 0.5rem",
                            backgroundColor: "#64748b",
                            color: "white",
                            borderRadius: "0.25rem",
                            border: "none",
                            cursor: "pointer",
                            opacity: loadingColumns ? 0.5 : 1,
                          }}
                        >
                          Clear All
                        </button>
                      </div>
                    </div>

                    {loadingColumns ? (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "1rem",
                          color: "#64748b",
                        }}
                      >
                        Loading columns...
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fill, minmax(200px, 1fr))",
                          gap: "0.5rem",
                          maxHeight: "200px",
                          overflowY: "auto",
                          padding: "0.5rem",
                          border: "1px solid #e5e7eb",
                          borderRadius: "0.375rem",
                          backgroundColor: "white",
                        }}
                      >
                        {tableColumns.map((column) => (
                          <label
                            key={column}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              cursor: "pointer",
                              padding: "0.25rem",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={selectedColumns.includes(column)}
                              onChange={() => toggleColumnSelection(column)}
                            />
                            <span>{column}</span>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Joins Section */}
                {selectedTable && (
                  <div style={{ marginBottom: "1.5rem" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <h3 style={{ fontSize: "0.875rem", fontWeight: "600" }}>
                        Table Joins
                        <span
                          style={{
                            fontSize: "0.75rem",
                            color: "#4b5563",
                            marginLeft: "0.5rem",
                            fontWeight: "normal",
                          }}
                        >
                          (Main Table: {selectedTable})
                        </span>
                      </h3>
                    </div>

                    {joins.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          marginBottom: "1rem",
                        }}
                      >
                        {joins.map((join, joinIndex) => (
                          <div
                            key={joinIndex}
                            style={{
                              border: "1px solid #e5e7eb",
                              borderRadius: "0.5rem",
                              padding: "1rem",
                              backgroundColor: "#f8fafc",
                              position: "relative",
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                top: "0.5rem",
                                right: "0.5rem",
                                display: "flex",
                                gap: "0.5rem",
                              }}
                            >
                              <button
                                onClick={() => removeJoin(joinIndex)}
                                style={{
                                  padding: "0.25rem",
                                  color: "#ef4444",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                title="Remove join"
                              >
                                <Trash2 size={16} />
                              </button>
                            </div>

                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "1rem",
                                marginBottom: "1rem",
                              }}
                            >
                              {/* Join Type */}
                              <div>
                                <label
                                  style={{
                                    display: "block",
                                    marginBottom: "0.25rem",
                                    fontSize: "0.75rem",
                                    color: "#64748b",
                                  }}
                                >
                                  Join Type
                                </label>
                                <select
                                  value={join.type}
                                  onChange={(e) =>
                                    updateJoin(
                                      joinIndex,
                                      "type",
                                      e.target.value
                                    )
                                  }
                                  style={{
                                    width: "100%",
                                    padding: "0.5rem",
                                    borderRadius: "0.25rem",
                                    border: "1px solid #d1d5db",
                                  }}
                                >
                                  {joinTypes.map((type) => (
                                    <option key={type} value={type}>
                                      {type} JOIN
                                    </option>
                                  ))}
                                </select>
                              </div>

                              {/* Join Table */}
                              <div>
                                <label
                                  style={{
                                    display: "block",
                                    marginBottom: "0.25rem",
                                    fontSize: "0.75rem",
                                    color: "#64748b",
                                  }}
                                >
                                  Join Table
                                </label>
                                <select
                                  value={join.table}
                                  onChange={(e) =>
                                    updateJoin(
                                      joinIndex,
                                      "table",
                                      e.target.value
                                    )
                                  }
                                  style={{
                                    width: "100%",
                                    padding: "0.5rem",
                                    borderRadius: "0.25rem",
                                    border: "1px solid #d1d5db",
                                  }}
                                >
                                  <option value="">Select table to join</option>
                                  {tablesData
                                    .filter((table) => table !== selectedTable)
                                    .map((table) => (
                                      <option key={table} value={table}>
                                        {table}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>

                            {/* ON condition preview */}
                            {join.table && join.conditions.length > 0 && (
                              <div style={{ marginBottom: "1rem" }}>
                                <label
                                  style={{
                                    display: "block",
                                    marginBottom: "0.25rem",
                                    fontSize: "0.75rem",
                                    color: "#64748b",
                                  }}
                                >
                                  ON Condition Preview
                                </label>
                                <div
                                  style={{
                                    padding: "0.75rem",
                                    backgroundColor: "#f3f4f6",
                                    borderRadius: "0.375rem",
                                    border: "1px solid #e5e7eb",
                                    fontSize: "0.875rem",
                                    color: "#374151",
                                    fontFamily: "monospace",
                                  }}
                                >
                                  {join.conditions.map((cond, i) => (
                                    <div key={i}>
                                      {i > 0 && (
                                        <span style={{ color: "#6b7280" }}>
                                          {cond.conditionType}{" "}
                                        </span>
                                      )}
                                      <span>
                                        {/* Display the actual condition as it will be generated */}
                                        {cond.leftTable || selectedTable}.{cond.firstTableColumn}{" "}
                                        {cond.operator} {join.table}.
                                        {cond.secondTableColumn}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}

                            {/* Join Conditions */}
                            <div style={{ marginBottom: "1rem" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "0.5rem",
                                }}
                              >
                                <h4
                                  style={{
                                    fontSize: "0.75rem",
                                    fontWeight: "600",
                                    color: "#4b5563",
                                  }}
                                >
                                  Join Conditions
                                </h4>
                                <button
                                  onClick={() => addJoinCondition(joinIndex)}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.25rem",
                                    padding: "0.25rem 0.5rem",
                                    backgroundColor: "#10b981",
                                    color: "white",
                                    borderRadius: "0.25rem",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "0.75rem",
                                  }}
                                >
                                  <Plus size={12} />
                                  Add Condition
                                </button>
                              </div>

                              {join.conditions.map((condition, condIndex) => {
                                // Get all available tables for this join condition
                                const availableLeftTables = [
                                  { name: selectedTable, display: selectedTable, isMain: true },
                                  ...joins.slice(0, joinIndex).filter(prevJoin => prevJoin.table).map(prevJoin => ({
                                    name: prevJoin.table,
                                    display: prevJoin.table,
                                    isMain: false
                                  }))
                                ];

                                const currentLeftTable = condition.leftTable || selectedTable;

                                // Get columns and data types for the selected left table
                                let leftTableColumns = [];
                                let leftTableDataTypes = {};
                                if (currentLeftTable === selectedTable) {
                                  leftTableColumns = tableColumns;
                                  leftTableDataTypes = columnDataTypes;
                                } else {
                                  leftTableColumns = joinTableColumns[currentLeftTable]?.columns || [];
                                  leftTableDataTypes = joinTableColumns[currentLeftTable]?.dataTypes || {};
                                }

                                // Get columns and data types for the current join table (right side)
                                const rightTableColumns = joinTableColumns[join.table]?.columns || [];
                                const rightTableDataTypes = joinTableColumns[join.table]?.dataTypes || {};

                                // Get data types for selected columns
                                const leftColumnDataType = leftTableDataTypes[condition.firstTableColumn] || "";
                                const rightColumnDataType = rightTableDataTypes[condition.secondTableColumn] || "";

                                // Determine available operators based on the selected columns' data types
                                let availableOperators = ["=", "!="]; // Default

                                if (condition.firstTableColumn && condition.secondTableColumn) {
                                  // If both columns are selected, use the more restrictive set of operators
                                  const leftOperators = getOperatorsForDataType(leftColumnDataType);
                                  const rightOperators = getOperatorsForDataType(rightColumnDataType);

                                  // Find intersection of operators supported by both data types
                                  availableOperators = leftOperators.filter(op => rightOperators.includes(op));

                                  // If no common operators, fall back to basic equality
                                  if (availableOperators.length === 0) {
                                    availableOperators = ["=", "!="];
                                  }
                                } else if (condition.firstTableColumn) {
                                  // If only left column is selected, use its operators
                                  availableOperators = getOperatorsForDataType(leftColumnDataType);
                                } else if (condition.secondTableColumn) {
                                  // If only right column is selected, use its operators
                                  availableOperators = getOperatorsForDataType(rightColumnDataType);
                                }

                                return (
                                  <div
                                    key={condIndex}
                                    style={{
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      marginBottom: "0.5rem",
                                      position: "relative"
                                    }}
                                  >
                                    {condIndex > 0 && (
                                      <select
                                        value={condition.conditionType}
                                        onChange={(e) =>
                                          updateJoinCondition(
                                            joinIndex,
                                            condIndex,
                                            "conditionType",
                                            e.target.value
                                          )
                                        }
                                        style={{
                                          width: "80px",
                                          padding: "0.5rem",
                                          borderRadius: "0.25rem",
                                          border: "1px solid #d1d5db",
                                        }}
                                      >
                                        {conditionTypes.map((type) => (
                                          <option key={type} value={type}>
                                            {type}
                                          </option>
                                        ))}
                                      </select>
                                    )}

                                    {/* LEFT TABLE SELECTION */}
                                    <select
                                      value={currentLeftTable}
                                      onChange={(e) => {
                                        updateJoinCondition(
                                          joinIndex,
                                          condIndex,
                                          "leftTable",
                                          e.target.value
                                        );
                                        updateJoinCondition(
                                          joinIndex,
                                          condIndex,
                                          "firstTableColumn",
                                          ""
                                        );
                                      }}
                                      style={{
                                        width: "140px",
                                        padding: "0.5rem",
                                        borderRadius: "0.25rem",
                                        border: "1px solid #d1d5db",
                                      }}
                                    >
                                      {availableLeftTables.map((table) => (
                                        <option key={`left-${table.name}`} value={table.name}>
                                          {table.display}
                                        </option>
                                      ))}
                                    </select>

                                    {/* LEFT TABLE COLUMN SELECTION */}
                                    <select
                                      value={condition.firstTableColumn}
                                      onChange={(e) =>
                                        updateJoinCondition(
                                          joinIndex,
                                          condIndex,
                                          "firstTableColumn",
                                          e.target.value
                                        )
                                      }
                                      style={{
                                        flex: 1,
                                        padding: "0.5rem",
                                        borderRadius: "0.25rem",
                                        border: "1px solid #d1d5db",
                                      }}
                                    >
                                      <option value="">
                                        Select {currentLeftTable} column
                                      </option>
                                      {leftTableColumns.map((column) => (
                                        <option key={`left-col-${column}`} value={column}>
                                          {column}
                                        </option>
                                      ))}
                                    </select>

                                    {/* LEFT COLUMN DATA TYPE DISPLAY BOX */}
                                    <input
                                      type="text"
                                      value={leftColumnDataType || ""}
                                      placeholder="Data Type"
                                      disabled
                                      style={{
                                        width: "100px",
                                        padding: "0.5rem",
                                        borderRadius: "0.25rem",
                                        border: "1px solid #d1d5db",
                                        backgroundColor: "#f3f4f6",
                                        color: "#6b7280",
                                      }}
                                    />

                                    {/* OPERATOR SELECTION - NOW DATA TYPE AWARE */}
                                    <select
                                      value={condition.operator}
                                      onChange={(e) =>
                                        updateJoinCondition(
                                          joinIndex,
                                          condIndex,
                                          "operator",
                                          e.target.value
                                        )
                                      }
                                      style={{
                                        width: "100px",
                                        padding: "0.5rem",
                                        borderRadius: "0.25rem",
                                        border: "1px solid #d1d5db",
                                      }}
                                      title={`Available operators for ${leftColumnDataType || 'selected'} data type`}
                                    >
                                      {availableOperators.map((op) => (
                                        <option key={op} value={op}>
                                          {op}
                                        </option>
                                      ))}
                                    </select>

                                    {/* RIGHT TABLE COLUMN SELECTION */}
                                    <select
                                      value={condition.secondTableColumn}
                                      onChange={(e) =>
                                        updateJoinCondition(
                                          joinIndex,
                                          condIndex,
                                          "secondTableColumn",
                                          e.target.value
                                        )
                                      }
                                      disabled={!join.table}
                                      style={{
                                        flex: 1,
                                        padding: "0.5rem",
                                        borderRadius: "0.25rem",
                                        border: "1px solid #d1d5db",
                                        opacity: join.table ? 1 : 0.7,
                                      }}
                                    >
                                      <option value="">
                                        Select {join.table || "table"} column
                                      </option>
                                      {rightTableColumns.map((column) => (
                                        <option key={`right-col-${column}`} value={column}>
                                          {column}
                                        </option>
                                      ))}
                                    </select>

                                    {/* RIGHT COLUMN DATA TYPE DISPLAY BOX */}
                                    <input
                                      type="text"
                                      value={rightColumnDataType || ""}
                                      placeholder="Data Type"
                                      disabled
                                      style={{
                                        width: "100px",
                                        padding: "0.5rem",
                                        borderRadius: "0.25rem",
                                        border: "1px solid #d1d5db",
                                        backgroundColor: "#f3f4f6",
                                        color: "#6b7280",
                                      }}
                                    />

                                    <button
                                      onClick={() =>
                                        removeJoinCondition(joinIndex, condIndex)
                                      }
                                      style={{
                                        padding: "0.5rem",
                                        color: "#ef4444",
                                        backgroundColor: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Trash2 size={16} />
                                    </button>

                                    {/* Data type compatibility warning */}
                                    {condition.firstTableColumn && condition.secondTableColumn &&
                                      leftColumnDataType && rightColumnDataType &&
                                      !areTypesCompatible(leftColumnDataType, rightColumnDataType) && (
                                        <div style={{
                                          position: "absolute",
                                          bottom: "-22px",
                                          left: "0",
                                          fontSize: "0.75rem",
                                          color: "#ef4444",
                                          backgroundColor: "#fef2f2",
                                          padding: "2px 6px",
                                          borderRadius: "4px",
                                          border: "1px solid #fecaca",
                                          whiteSpace: "nowrap",
                                          zIndex: 10
                                        }}>
                                          ⚠️ Type mismatch: {leftColumnDataType} vs {rightColumnDataType}
                                        </div>
                                      )}
                                  </div>
                                );
                              })}



                            </div>

                            {/* Join Column Selection */}
                            {join.table && (
                              <div
                                style={{
                                  marginTop: "1rem",
                                  backgroundColor: "#f0f9ff",
                                  borderRadius: "0.5rem",
                                  padding: "0.75rem",
                                  border: "1px solid #1a7a73",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "0.5rem",
                                  }}
                                >
                                  <h4
                                    style={{
                                      fontSize: "0.75rem",
                                      fontWeight: "600",
                                      color: "#0f3d3a",
                                    }}
                                  >
                                    Select columns to include from {join.table}
                                  </h4>
                                  <div
                                    style={{ display: "flex", gap: "0.5rem" }}
                                  >
                                    <button
                                      onClick={() => {
                                        const allColumns =
                                          joinTableColumns[join.table]
                                            ?.columns || [];
                                        updateJoin(
                                          joinIndex,
                                          "columns",
                                          allColumns
                                        );
                                      }}
                                      style={{
                                        padding: "0.25rem 0.5rem",
                                        fontSize: "0.625rem",
                                        backgroundColor: "#1a7a73",
                                        color: "white",
                                        borderRadius: "0.25rem",
                                        border: "none",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Select All
                                    </button>
                                    <button
                                      onClick={() =>
                                        updateJoin(joinIndex, "columns", [])
                                      }
                                      style={{
                                        padding: "0.25rem 0.5rem",
                                        fontSize: "0.625rem",
                                        backgroundColor: "#64748b",
                                        color: "white",
                                        borderRadius: "0.25rem",
                                        border: "none",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Clear All
                                    </button>
                                  </div>
                                </div>

                                {joinTableColumns[join.table]?.columns?.length >
                                0 ? (
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns:
                                        "repeat(auto-fill, minmax(180px, 1fr))",
                                      gap: "0.5rem",
                                      maxHeight: "150px",
                                      overflowY: "auto",
                                      padding: "0.5rem",
                                      border: "1px solid #e5e7eb",
                                      borderRadius: "0.375rem",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    {joinTableColumns[join.table].columns.map(
                                      (column) => {
                                        const dataType =
                                          joinTableColumns[join.table]
                                            .dataTypes[column];
                                        return (
                                          <label
                                            key={column}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "0.5rem",
                                              cursor: "pointer",
                                              padding: "0.25rem",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                            title={`${column} (${dataType})`}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={(
                                                join.columns || []
                                              ).includes(column)}
                                              onChange={() =>
                                                toggleJoinColumnSelection(
                                                  joinIndex,
                                                  column
                                                )
                                              }
                                            />
                                            <span
                                              style={{ fontSize: "0.75rem" }}
                                            >
                                              {column}
                                              <span
                                                style={{
                                                  color: "#6b7280",
                                                  fontSize: "0.625rem",
                                                  marginLeft: "0.25rem",
                                                }}
                                              >
                                                {/* {dataType} */}
                                              </span>
                                            </span>
                                          </label>
                                        );
                                      }
                                    )}
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      padding: "0.5rem",
                                      textAlign: "center",
                                      color: "#64748b",
                                      fontSize: "0.75rem",
                                    }}
                                  >
                                    {joinTableColumns[join.table]
                                      ? "No columns available"
                                      : "Loading columns..."}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Add Join button moved below existing joins */}
                    <button
                      onClick={addJoin}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.25rem",
                        padding: "0.5rem 1rem",
                        backgroundColor: "#8b5cf6",
                        color: "white",
                        borderRadius: "0.5rem",
                        border: "none",
                        cursor: "pointer",
                        marginLeft: "auto",
                      }}
                    >
                      <Plus size={16} />
                      Add Join
                    </button>
                  </div>
                )}

                {/* Filters Section */}
                <div style={{ marginBottom: "1.5rem" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <h3 style={{ fontSize: "0.875rem", fontWeight: "600" }}>
                      Filters
                    </h3>
                    <button
                      onClick={addCondition}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.25rem",
                        padding: "0.25rem 0.5rem",
                        backgroundColor: "#1a7a73",
                        color: "white",
                        borderRadius: "0.25rem",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <Plus size={14} />
                      Add Filter
                    </button>
                  </div>

                  {conditions.map((condition, index) => {
                    const availableTables = [
                      { name: selectedTable, display: selectedTable, isMain: true },
                      ...joins
                        .filter(join => join.table && joinTableColumns[join.table]?.columns)
                        .map(join => ({
                          name: join.table,
                          display: join.table,
                          isMain: false
                        }))
                    ];

                    const currentTable = condition.table !== undefined ? condition.table : selectedTable;
                    const currentColumns = currentTable === selectedTable
                      ? tableColumns
                      : (joinTableColumns[currentTable]?.columns || []);

                    const dataType = condition.field ? getDataTypeForField(currentTable, condition.field) : "";

                    // Get available operators based on the data type
                    const availableOperators = dataType ? getOperatorsForDataType(dataType) : operatorTypes;

                    const isValid = !condition.field || !condition.value ||
                      validateValue(currentTable, condition.field, condition.value, condition.operator);

                    const getPlaceholder = () => {
                      if (condition.operator === "BETWEEN") {
                        if (dataType?.toLowerCase().includes("date") || dataType?.toLowerCase().includes("timestamp")) {
                          return "Start Date, End Date (YYYY-MM-DD, YYYY-MM-DD)";
                        }
                        return "Start Value, End Value";
                      }
                      if (["IN", "NOT IN"].includes(condition.operator)) {
                        return "Comma separated values";
                      }
                      if (dataType?.toLowerCase().includes("date") || dataType?.toLowerCase().includes("timestamp")) {
                        return "YYYY-MM-DD or YYYY-MM-DD HH:MM:SS";
                      }
                      if (dataType?.toLowerCase().includes("boolean")) {
                        return "true/false, yes/no, or 1/0";
                      }
                      if (dataType?.toLowerCase().includes("int") || dataType?.toLowerCase().includes("numeric")) {
                        return "Enter a number";
                      }
                      return "Value";
                    };

                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          alignItems: "flex-start",
                          position: "relative",
                          marginTop: "16px"
                        }}
                      >
                        {/* Table selection dropdown */}
                        <select
                          value={currentTable}
                          onChange={(e) => updateCondition(index, "table", e.target.value)}
                          style={{
                            width: "180px",
                            padding: "0.5rem",
                            borderRadius: "0.25rem",
                            border: "1px solid #d1d5db",
                          }}
                        >
                          <option value="">Select table</option>
                          {availableTables.map(table => (
                            <option key={table.name} value={table.name}>
                              {table.display}
                            </option>
                          ))}
                        </select>

                        {/* Field selection dropdown */}
                        <select
                          value={condition.field || ""}
                          onChange={(e) => updateCondition(index, "field", e.target.value)}
                          disabled={!currentTable}
                          style={{
                            flex: 1,
                            padding: "0.5rem",
                            borderRadius: "0.25rem",
                            border: "1px solid #d1d5db",
                            opacity: !currentTable ? 0.7 : 1,
                          }}
                        >
                          <option value="">Select column</option>
                          {currentColumns.map((field) => (
                            <option key={field} value={field}>
                              {field}
                            </option>
                          ))}
                        </select>

                        {/* Data type display with color coding */}
                        <input
                          type="text"
                          value={dataType || ""}
                          placeholder="Data Type"
                          disabled
                          style={{
                            width: "120px",
                            padding: "0.5rem",
                            borderRadius: "0.25rem",
                            border: "1px solid #d1d5db",
                            backgroundColor: dataType ? "#f0f9ff" : "#f3f4f6",
                            color: dataType ? "#0f3d3a" : "#6b7280",
                            fontWeight: dataType ? "500" : "normal",
                          }}
                        />

                        {/* OPERATOR DROPDOWN - NOW DATA TYPE AWARE */}
                        <select
                          value={condition.operator}
                          onChange={(e) => updateCondition(index, "operator", e.target.value)}
                          style={{
                            width: "120px",
                            padding: "0.5rem",
                            borderRadius: "0.25rem",
                            border: "1px solid #d1d5db",
                          }}
                          title={`Available operators for ${dataType || 'selected'} data type`}
                        >
                          {availableOperators.map((op) => (
                            <option key={op} value={op}>
                              {op}
                            </option>
                          ))}
                        </select>

                        {/* Value input with enhanced validation */}
                        <div style={{ flex: 1, position: "relative" }}>
                          <input
                            type="text"
                            value={condition.value}
                            onChange={(e) => updateCondition(index, "value", e.target.value)}
                            placeholder={getPlaceholder()}
                            style={{
                              width: "100%",
                              padding: "0.5rem",
                              borderRadius: "0.25rem",
                              border: `1px solid ${isValid ? "#d1d5db" : "#ef4444"}`,
                              backgroundColor: isValid ? "white" : "#fef2f2",
                            }}
                          />
                          {!isValid && condition.value && (
                            <div
                              style={{
                                position: "absolute",
                                bottom: "-20px",
                                left: 0,
                                fontSize: "0.75rem",
                                color: "#ef4444",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {getValidationErrorMessage(dataType, condition.operator, condition.value)}
                            </div>
                          )}

                          {/* Helper text for valid inputs */}
                          {isValid && condition.value && (
                            <div
                              style={{
                                position: "absolute",
                                bottom: "-20px",
                                left: 0,
                                fontSize: "0.75rem",
                                color: "#10b981",
                              }}
                            >
                              {condition.operator === "BETWEEN" && dataType?.toLowerCase().includes("date")
                                ? "Format: Start Date, End Date"
                                : condition.operator === "BETWEEN"
                                  ? "Format: Min Value, Max Value"
                                  : ["IN", "NOT IN"].includes(condition.operator)
                                    ? "Comma-separated values"
                                    : "Valid input"
                              }
                            </div>
                          )}
                        </div>

                        {/* Remove button */}
                        <button
                          onClick={() => removeCondition(index)}
                          style={{
                            padding: "0.5rem",
                            color: "#ef4444",
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    );
                  })}
                </div>


{/* Sort Section */}
<div style={{ marginBottom: "1.5rem" }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
    <h3 style={{ fontSize: "0.875rem", fontWeight: "600" }}>Sorting</h3>
    <button
      onClick={addOrderByField}
      style={{
        display: "flex", alignItems: "center", gap: "0.25rem",
        padding: "0.25rem 0.5rem", backgroundColor: "#10b981",
        color: "white", borderRadius: "0.25rem", border: "none", cursor: "pointer"
      }}
    >
      <Plus size={14} /> Add Sort Field
    </button>
  </div>

  {orderByFields.length > 0 && (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      {orderByFields.map((field, index) => {
        // Get all available tables (main + joined)
        const availableTables = [
          { name: selectedTable, display: `${selectedTable}`, isMain: true },
          ...joins
            .filter(join => join.table && joinTableColumns[join.table]?.columns)
            .map(join => ({
              name: join.table,
              display: join.table,
              isMain: false
            }))
        ];

        // Get columns for the currently selected table in this field
        const currentColumns = field.table === selectedTable 
          ? tableColumns 
          : (joinTableColumns[field.table]?.columns || []);

        return (
          <div key={`sort-${index}-${field.table}`} style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
            {/* Table selection */}
            <select
              value={field.table || ""}
              onChange={(e) => {
                const newTable = e.target.value;
                const updatedFields = [...orderByFields];
                updatedFields[index] = { 
                  ...updatedFields[index], 
                  table: newTable,
                  column: "" // Reset column when table changes
                };
                setOrderByFields(updatedFields);
              }}
              style={{ width: "200px", padding: "0.5rem", borderRadius: "0.25rem", border: "1px solid #d1d5db" }}
            >
              <option value="">Select table</option>
              {availableTables.map(table => (
                <option key={`table-${table.name}`} value={table.name}>
                  {table.display}
                </option>
              ))}
            </select>

            {/* Column selection */}
            <select
              value={field.column || ""}
              onChange={(e) => {
                const updatedFields = [...orderByFields];
                updatedFields[index].column = e.target.value;
                setOrderByFields(updatedFields);
              }}
              disabled={!field.table}
              style={{ flex: 1, padding: "0.5rem", borderRadius: "0.25rem", border: "1px solid #d1d5db" }}
            >
              <option value="">Select column</option>
              {currentColumns.map(column => (
                <option key={`col-${field.table}-${column}`} value={column}>
                  {column}
                </option>
              ))}
            </select>

            {/* Sort direction */}
            <select
              value={field.direction}
              onChange={(e) => {
                const updatedFields = [...orderByFields];
                updatedFields[index].direction = e.target.value;
                setOrderByFields(updatedFields);
              }}
              style={{ width: "120px", padding: "0.5rem", borderRadius: "0.25rem", border: "1px solid #d1d5db" }}
            >
              <option value="ASC">Ascending</option>
              <option value="DESC">Descending</option>
            </select>

            <button
              onClick={() => {
                const updatedFields = [...orderByFields];
                updatedFields.splice(index, 1);
                setOrderByFields(updatedFields);
              }}
              style={{ padding: "0.5rem", color: "#ef4444", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
            >
              <Trash2 size={16} />
            </button>
          </div>
        );
      })}
    </div>
  )}
</div>
                <div style={{ marginBottom: "1.5rem" }}>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "0.5rem",
    }}
  >
    <h3 style={{ fontSize: "0.875rem", fontWeight: "600" }}>
      Aggregators
    </h3>
    <button
      onClick={addAggregator}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.25rem",
        padding: "0.25rem 0.5rem",
        backgroundColor: "#f59e0b",
        color: "white",
        borderRadius: "0.25rem",
        border: "none",
        cursor: "pointer",
      }}
    >
      <Plus size={14} />
      Add Aggregator
    </button>
  </div>

  {aggregators.length > 0 && (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
      }}
    >
      {aggregators.map((aggregator, index) => {
        // Get all available tables (main + joined)
        const availableTables = [
          { name: selectedTable, display: `${selectedTable}`, isMain: true },
          ...joins
            .filter(join => join.table && joinTableColumns[join.table]?.columns)
            .map(join => ({
              name: join.table,
              display: join.table,
              isMain: false
            }))
        ];

        // Get columns for the currently selected table in this aggregator
        const currentColumns = aggregator.table === selectedTable 
          ? tableColumns 
          : (joinTableColumns[aggregator.table]?.columns || []);

        return (
          <div
            key={`aggregator-${index}-${aggregator.table}`}
            style={{
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
            }}
          >
            {/* Aggregation Function */}
            <select
              value={aggregator.function}
              onChange={(e) =>
                updateAggregator(index, "function", e.target.value)
              }
              style={{
                width: "120px",
                padding: "0.5rem",
                borderRadius: "0.25rem",
                border: "1px solid #d1d5db",
              }}
            >
              {aggregatorTypes.map((func) => (
                <option key={func} value={func}>
                  {func}
                </option>
              ))}
            </select>

            {/* Table selection */}
            <select
              value={aggregator.table || ""}
              onChange={(e) =>
                updateAggregator(index, "table", e.target.value)
              }
              style={{
                width: "200px",
                padding: "0.5rem",
                borderRadius: "0.25rem",
                border: "1px solid #d1d5db",
              }}
            >
              <option value="">Select table</option>
              {availableTables.map(table => (
                <option key={`agg-table-${table.name}`} value={table.name}>
                  {table.display}
                </option>
              ))}
            </select>

            {/* Column selection */}
            <select
              value={aggregator.column}
              onChange={(e) =>
                updateAggregator(index, "column", e.target.value)
              }
              disabled={!aggregator.table}
              style={{
                flex: 1,
                padding: "0.5rem",
                borderRadius: "0.25rem",
                border: "1px solid #d1d5db",
              }}
            >
              <option value="">Select column</option>
              {currentColumns.map((column) => (
                <option key={`agg-col-${aggregator.table}-${column}`} value={column}>
                  {column}
                </option>
              ))}
            </select>

            {/* Alias input */}
            {/* <input
              type="text"
              value={aggregator.alias}
              onChange={(e) =>
                updateAggregator(index, "alias", e.target.value)
              }
              placeholder="Alias (optional)"
              style={{
                width: "150px",
                padding: "0.5rem",
                borderRadius: "0.25rem",
                border: "1px solid #d1d5db",
              }}
            /> */}

            {/* Remove button */}
            <button
              onClick={() => removeAggregator(index)}
              style={{
                padding: "0.5rem",
                color: "#ef4444",
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              <Trash2 size={16} />
            </button>
          </div>
        );
      })}
    </div>
  )}
</div>
{/* Group By Section */}
<div style={{ marginBottom: "1.5rem" }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
    <h3 style={{ fontSize: "0.875rem", fontWeight: "600" }}>
      Group By
      <span style={{ fontSize: "0.75rem", color: "#4b5563", marginLeft: "0.5rem", fontWeight: "normal" }}>
        (Required when using aggregators)
      </span>
    </h3>
    <button
      onClick={addGroupByField}
      style={{
        display: "flex", alignItems: "center", gap: "0.25rem",
        padding: "0.25rem 0.5rem", backgroundColor: "#8b5cf6",
        color: "white", borderRadius: "0.25rem", border: "none", cursor: "pointer"
      }}
    >
      <Plus size={14} /> Add Group Field
    </button>
  </div>

  {groupByFields.length > 0 && (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      {groupByFields.map((field, index) => {
        // Get all available tables (main + joined)
        const availableTables = [
          { name: selectedTable, display: `${selectedTable}`, isMain: true },
          ...joins
            .filter(join => join.table && joinTableColumns[join.table]?.columns)
            .map(join => ({
              name: join.table,
              display: join.table,
              isMain: false
            }))
        ];

        // Get columns for the currently selected table in this field
        const currentColumns = field.table === selectedTable 
          ? tableColumns 
          : (joinTableColumns[field.table]?.columns || []);

        return (
          <div key={`group-${index}-${field.table}`} style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
            {/* Table selection */}
            <select
              value={field.table || ""}
              onChange={(e) => {
                const newTable = e.target.value;
                const updatedFields = [...groupByFields];
                updatedFields[index] = { 
                  ...updatedFields[index], 
                  table: newTable,
                  column: "" // Reset column when table changes
                };
                setGroupByFields(updatedFields);
              }}
              style={{ width: "200px", padding: "0.5rem", borderRadius: "0.25rem", border: "1px solid #d1d5db" }}
            >
              <option value="">Select table</option>
              {availableTables.map(table => (
                <option key={`table-${table.name}`} value={table.name}>
                  {table.display}
                </option>
              ))}
            </select>

            {/* Column selection */}
            <select
              value={field.column || ""}
              onChange={(e) => {
                const updatedFields = [...groupByFields];
                updatedFields[index].column = e.target.value;
                setGroupByFields(updatedFields);
              }}
              disabled={!field.table}
              style={{ flex: 1, padding: "0.5rem", borderRadius: "0.25rem", border: "1px solid #d1d5db" }}
            >
              <option value="">Select column</option>
              {currentColumns.map(column => (
                <option key={`col-${field.table}-${column}`} value={column}>
                  {column}
                </option>
              ))}
            </select>

            <button
              onClick={() => {
                const updatedFields = [...groupByFields];
                updatedFields.splice(index, 1);
                setGroupByFields(updatedFields);
              }}
              style={{ padding: "0.5rem", color: "#ef4444", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
            >
              <Trash2 size={16} />
            </button>
          </div>
        );
      })}
    </div>
  )}
</div>

                {/* Action Buttons */}
                <div style={{ display: "flex", gap: "0.75rem" }}>
                  <button
                    onClick={buildJsonQuery}
                    disabled={!isValidQuery || !selectedTable}
                    style={{
                      padding: "0.5rem 1rem",
                      backgroundColor:
                        !isValidQuery || !selectedTable ? "#9ca3af" : "#1a7a73",
                      color: "white",
                      borderRadius: "0.5rem",
                      border: "none",
                      cursor:
                        !isValidQuery || !selectedTable
                          ? "not-allowed"
                          : "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <Play size={16} />
                    Build Query
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Results Section */}
        <div style={{ display: "flex", gap: "1.5rem", marginBottom: "1.5rem" }}>
          {/* JSON Query Panel */}
          <div
            style={{
              flex: 1,
              backgroundColor: "white",
              borderRadius: "0.75rem",
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "1rem",
                borderBottom: "1px solid #e5e7eb",
                backgroundColor: "#f9fafb",
              }}
            >
              <h3
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  color: "#1f2937",
                }}
              >
                Generated Query
              </h3>
            </div>
            <div
              style={{
                padding: "1rem",
                height: "400px",
                overflowY: "auto",
                backgroundColor: "#111827",
              }}
            >
              {jsonQuery ? (
                <>
                  <pre
                    style={{
                      color: "#f3f4f6",
                      fontSize: "0.875rem",
                      fontFamily: "monospace",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      margin: 0,
                    }}
                  >
                    {jsonQuery}
                  </pre>
                  <button
                    onClick={callNiFiAPI}
                    disabled={isExecuting || !jsonQuery || !isValidQuery}
                    style={{
                      marginTop: "1rem",
                      backgroundColor:
                        isExecuting || !jsonQuery || !isValidQuery
                          ? "#6b7280"
                          : "#10b981",
                      color: "white",
                      borderRadius: "0.5rem",
                      padding: "0.5rem 1rem",
                      fontWeight: "500",
                      fontSize: "0.875rem",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      border: "none",
                      cursor:
                        isExecuting || !jsonQuery || !isValidQuery
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    {isExecuting ? (
                      <>
                        <Loader2 size={16} className="animate-spin" />
                        Executing...
                      </>
                    ) : (
                      <>
                        <Play size={16} />
                        Execute Query
                      </>
                    )}
                  </button>
                </>
              ) : (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#6b7280",
                  }}
                >
                  <p>No query generated yet. Build a query first.</p>
                </div>
              )}
            </div>
          </div>

          {/* API Response Panel */}
          <div
            style={{
              flex: 1,
              backgroundColor: "white",
              borderRadius: "0.75rem",
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "1rem",
                borderBottom: "1px solid #e5e7eb",
                backgroundColor: "#f9fafb",
              }}
            >
              <h3
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  color: "#1f2937",
                }}
              >
                API Response
              </h3>
            </div>
            <div
              style={{ padding: "1rem", height: "400px", overflowY: "auto" }}
            >
              {jsonResponse ? (
                <pre
                  style={{
                    fontSize: "0.875rem",
                    fontFamily: "monospace",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    margin: 0,
                  }}
                >
                  {JSON.stringify(jsonResponse, null, 2)}
                </pre>
              ) : (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#6b7280",
                  }}
                >
                  <p>No response yet. Execute a query to see results.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add this confirmation modal at the end, before the closing div */}
    <ConfirmationModal
      isOpen={confirmModal.isOpen}
      onClose={() => setConfirmModal({ isOpen: false, title: "", message: "", onConfirm: null })}
      onConfirm={confirmModal.onConfirm}
      title={confirmModal.title}
      message={confirmModal.message}
    />
    </div>
  );
};

export default QueryBuilder;